export type FilterKey = 'all' | 'recommended' | 'love' | 'maybe' | 'skip'

interface FilterChipsProps {
  active: FilterKey
  onChange: (key: FilterKey) => void
  counts: { all: number; recommended: number; love: number; maybe: number; skip: number }
}

const ITEMS: { key: FilterKey; label: string }[] = [
  { key: 'all', label: 'All' },
  { key: 'recommended', label: 'Recommended' },
  { key: 'love', label: 'Selected' },
  { key: 'maybe', label: 'Undecided' },
  { key: 'skip', label: 'Rejected' },
]

export function FilterChips({ active, onChange, counts }: FilterChipsProps) {
  return (
    <div className="flex gap-1.5 px-4 pb-3 overflow-x-auto no-scrollbar flex-shrink-0">
      {ITEMS.map((item) => {
        const isActive = item.key === active
        return (
          <button
            key={item.key}
            onClick={() => onChange(item.key)}
            className={[
              'flex-shrink-0 inline-flex items-center h-9 px-3.5 rounded-full text-xs whitespace-nowrap border transition-colors',
              isActive
                ? 'bg-[var(--accent-primary)] text-[var(--text-on-accent)] border-[var(--accent-primary)] font-semibold'
                : 'bg-[var(--surface-secondary)] text-[var(--text-secondary)] border-[var(--border-subtle)]',
            ].join(' ')}
          >
            {item.label}
            <span className="ml-1 opacity-60">{counts[item.key]}</span>
          </button>
        )
      })}
    </div>
  )
}
